// extracted by mini-css-extract-plugin
module.exports = {"feedback":"_2Gt-X"};